module.exports = "<select class=\"form-control\" [(ngModel)]=\"_activeRole\" (change)=\"onChange($event.target.value)\" >\n  <option [value]=\"null\" disabled>Select a Role</option>\n  <option *ngFor=\"let role of roles\" value=\"{{role.name}}\">{{role.description}}</option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/rights/roles/select/select.component.html
// module id = ../../../../../angular/app/views/rights/roles/select/select.component.html
// module chunks = main